var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "ticket-card", attrs: { flat: "" } },
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c("v-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticClass: "d-flex justify-space-between align-center" },
              [
                _c("h3", { staticClass: "text-subtitle-1 font-weight-bold" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.isBonus
                          ? "贈られたチケット"
                          : _vm.ticket.ticket.name
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "v-chip",
                  {
                    attrs: {
                      color: _vm.getStatusColor(_vm.ticket),
                      "text-color": "white",
                      small: "",
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.getStatusText(_vm.ticket)) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-2" },
              [
                _c(
                  "div",
                  { staticClass: "d-flex align-center" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "mr-2", attrs: { small: "" } },
                      [_vm._v("mdi-ticket-outline")]
                    ),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.ticket.ticket_number) + "枚"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex align-center mt-1" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "mr-2", attrs: { small: "" } },
                      [_vm._v("mdi-calendar")]
                    ),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "購入日: " +
                          _vm._s(_vm.formatDate(_vm.ticket.created_at))
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.isBonus
                  ? [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center mt-1" },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-2", attrs: { small: "" } },
                            [_vm._v("mdi-calendar-clock")]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "有効期限: " +
                                _vm._s(_vm.formatDate(_vm.ticket.expired_at))
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex align-center mt-1" },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-2", attrs: { small: "" } },
                            [_vm._v("mdi-currency-jpy")]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "価格: " +
                                _vm._s(_vm.formatPrice(_vm.ticket.price))
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.isBonus
                  ? _c(
                      "div",
                      { staticClass: "d-flex align-center mt-1" },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "mr-2", attrs: { small: "" } },
                          [_vm._v("mdi-gift")]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("ボーナスチケット")]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }